export const scrollerBack = () => {
  const element = document.querySelector('#root');
  const offset = 140;
  const bodyRect = document.body.getBoundingClientRect().top;
  const elementRect = element.getBoundingClientRect().top;
  const elementPosition = elementRect - bodyRect;
  const offsetPosition = elementPosition - offset;

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth',
  });
};

export const sortBy = (values, dir) => {
  if (dir === 'alpha') {
    values.sort((a, b) => {
      const x = a.title;
      const y = b.title;
      return x > y ? 1 : -1;
    });
  }

  if (dir === 'new') {
    values.sort((a, b) => {
      const x = a.created;
      const y = b.created;
      return y - x;
    });
  }

  if (dir === 'low') {
    values.sort((a, b) => {
      const x = parseInt(a.msrp.max);
      const y = parseInt(b.msrp.max);
      return x - y;
    });
  }

  if (dir === 'high') {
    values.sort((a, b) => {
      const x = parseInt(a.msrp.max);
      const y = parseInt(b.msrp.max);
      return y - x;
    });
  }

  return values;
};
